import { useHead, useSeoMeta } from '@unhead/react'

export const SITE_URL = 'https://www.dormercalculator.com'
export const SITE_NAME = 'Dormer Calculator'

interface SeoProps {
  title: string
  description: string
  path: string
  type?: 'website' | 'article'
  image?: string
  schema?: Record<string, unknown> | Record<string, unknown>[]
  noindex?: boolean
}

function Seo({ title, description, path, type = 'website', image, schema, noindex }: SeoProps) {
  const url = `${SITE_URL}${path === '/' ? '' : path}`
  const schemas = schema ? (Array.isArray(schema) ? schema : [schema]) : []

  useHead({
    htmlAttrs: { lang: 'en' },
    title,
    link: [{ rel: 'canonical', href: url }],
    script: schemas.map((s, i) => ({
      key: `ld-json-${i}`,
      type: 'application/ld+json',
      innerHTML: JSON.stringify(s),
    })),
  })

  useSeoMeta({
    description,
    robots: noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large',
    ogTitle: title,
    ogDescription: description,
    ogType: type,
    ogUrl: url,
    ogSiteName: SITE_NAME,
    ogImage: image,
    twitterCard: image ? 'summary_large_image' : 'summary',
    twitterTitle: title,
    twitterDescription: description,
    twitterImage: image,
  })

  return null
}

export default Seo
